import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaSave, FaSpinner, FaTag } from 'react-icons/fa';
import { getLeadOriginById, createLeadOrigin, updateLeadOrigin } from './leadOriginService';
import DashboardLayout from '../../layouts/DashboardLayout';
import Input from '../../components/shared/Input';
import LoadingSpinner from '../../components/shared/LoadingSpinner';

import {
  FormContainer,
  FormSection,
  FormHeader,
  BackButton,
  FormGrid,
  FormField,
  SubmitButton
} from '../../components/styled/FormComponents';

const LeadOriginForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(!!id);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    origin_name: '', });

  useEffect(() => {
    const fetchLeadOrigin = async () => {
      if (!id) return;
      
      try {
        setInitialLoading(true);
        const response = await getLeadOriginById(id);
        setFormData({
          origin_name: response.data.origin_name
        });
      } catch (err) {
        setError('Failed to load lead origin details');
        console.error('Error fetching lead origin:', err);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchLeadOrigin();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (id) {
        await updateLeadOrigin(id, formData);
      } else {
        await createLeadOrigin(formData);
      }
      navigate('/leads/origins');
    } catch (err) {
      setError(err.message || 'Failed to save lead origin');
      console.error('Error saving lead origin:', err);
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return (
      <DashboardLayout>
        <FormContainer>
          <FormSection>
            <LoadingSpinner />
          </FormSection>
        </FormContainer>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <FormContainer>
        <FormHeader>
          <BackButton onClick={() => navigate('/leads/origins')}>
            <FaArrowLeft /> Back to Lead Origins
          </BackButton>
          <h2>{id ? 'Edit Lead Origin' : 'New Lead Origin'}</h2>
        </FormHeader>

        {error && (
          <FormSection>
            <div className="error-message" style={{ color: 'red', marginBottom: '1rem' }}>
              {error}
            </div>
          </FormSection>
        )}

        <form onSubmit={handleSubmit}>
          <FormSection>
            <h3>Origin Details</h3>
            <FormGrid>
              <FormField index={0}>
                <Input
                  label="Origin Name"
                  icon={<FaTag />}
                  value={formData.origin_name}
                  onChange={(e) => setFormData({ ...formData, origin_name: e.target.value })}
                  placeholder="Enter origin name"
                  required
                />
              </FormField>
            </FormGrid>
          </FormSection>

          <SubmitButton type="submit" disabled={loading}>
            {loading ? (
              <>
                <FaSpinner className="icon-spin" /> Saving...
              </>
            ) : (
              <>
                <FaSave /> {id ? 'Update Origin' : 'Create Origin'}
              </>
            )}
          </SubmitButton>
        </form>
      </FormContainer>
    </DashboardLayout>
  );
};

export default LeadOriginForm;